// GA4 퍼널 이벤트 헬퍼.
// gtag 는 public/index.html 의 스니펫에서 로드됨. 광고 차단·미로딩 환경에서도
// 안전하게 no-op 하도록 모든 호출을 가드한다.
//
// 퍼널 개요
//   [공통]     view_item_list  — 홈(폼+구독카드) 노출
//   [인증]     sign_up / login — 회원가입·로그인
//   [구독]     select_item → begin_checkout → purchase → onboarding_start
//              → onboarding_step_complete → onboarding_complete
//              → preview_brief_request → preview_brief_success(+generate_lead)
//   [1회분석]  begin_checkout → purchase

const CURRENCY = 'USD';

// GA4 ecommerce item 형식. price 는 결제 화면(Polar) 표기 기준.
export const PRODUCTS = {
  report: {
    item_id: 'style_report_oneoff',
    item_name: 'AI Style Report (one-off)',
    item_category: 'one_time',
    price: 6.99,
    quantity: 1,
  },
  subscription: {
    item_id: 'aura_daily_monthly',
    item_name: 'Aura Daily Monthly',
    item_category: 'subscription',
    price: 9.99,
    quantity: 1,
  },
};

export function track(event, params = {}) {
  if (typeof window === 'undefined') return;
  const fn = window.gtag;
  if (typeof fn !== 'function') return;
  try {
    fn('event', event, params);
  } catch {
    /* gtag 미로딩/차단 — 무시 */
  }
}

// 새로고침·재시도로 같은 transaction 이 다시 발화되는 것을 막는다.
// (예: 결제 복귀 페이지를 새로고침, 리포트 생성 재시도)
function trackOnce(key, event, params = {}) {
  if (typeof window === 'undefined') return;
  try {
    const k = `ga_once:${key}`;
    if (window.sessionStorage.getItem(k)) return;
    window.sessionStorage.setItem(k, '1');
  } catch {
    /* sessionStorage 불가 시 그냥 1회 발화 */
  }
  track(event, params);
}

export const funnel = {
  // ── 공통 ──
  viewHome() {
    track('view_item_list', {
      item_list_id: 'home',
      item_list_name: 'Home',
      items: [PRODUCTS.report, PRODUCTS.subscription],
    });
  },

  // ── 인증 ──
  login(method) {
    track('login', { method });
  },
  signUp(method) {
    track('sign_up', { method });
  },

  // ── 구독 퍼널 ──
  subscribeCtaClick(loggedIn) {
    track('select_item', {
      item_list_id: 'subscription',
      items: [PRODUCTS.subscription],
      logged_in: !!loggedIn,
    });
  },
  subscribeLoginRequired() {
    track('subscribe_login_required', {
      items: [PRODUCTS.subscription],
    });
  },
  beginCheckoutSubscription() {
    track('begin_checkout', {
      currency: CURRENCY,
      value: PRODUCTS.subscription.price,
      items: [PRODUCTS.subscription],
    });
  },
  purchaseSubscription(transactionId) {
    trackOnce(`sub:${transactionId || 'na'}`, 'purchase', {
      transaction_id: transactionId || `sub_${Date.now()}`,
      currency: CURRENCY,
      value: PRODUCTS.subscription.price,
      coupon: 'free_trial_7d',
      items: [PRODUCTS.subscription],
    });
  },
  onboardingStart() {
    trackOnce('onboarding_start', 'onboarding_start', {});
  },
  onboardingStep(stepNumber, stepName) {
    track('onboarding_step_complete', {
      step_number: stepNumber,
      step_name: stepName,
    });
  },
  onboardingComplete() {
    track('onboarding_complete', {});
  },
  previewBriefRequest() {
    track('preview_brief_request', {});
  },
  previewBriefSuccess() {
    // 온보딩의 핵심 활성화 지점 → 표준 generate_lead 로도 함께 보고.
    track('generate_lead', { currency: CURRENCY, value: PRODUCTS.subscription.price });
    track('preview_brief_success', {});
  },

  // ── 1회 분석 퍼널 ──
  beginCheckoutReport() {
    track('begin_checkout', {
      currency: CURRENCY,
      value: PRODUCTS.report.price,
      items: [PRODUCTS.report],
    });
  },
  purchaseReport(transactionId) {
    trackOnce(`report:${transactionId || 'na'}`, 'purchase', {
      transaction_id: transactionId || `rep_${Date.now()}`,
      currency: CURRENCY,
      value: PRODUCTS.report.price,
      items: [PRODUCTS.report],
    });
  },
};
